module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/199.1212c1c5.png";